export default "__VITE_ASSET__DaX5UtFg__"